export default __webpack_public_path__ + "static/media/image.9cd8a97d.png";